<template>
    <div class="vip-container">
        <div class="header">
            <div class="header-vip"></div>
            <div class="search-container">
                <a-input-search
                    placeholder="请输入关键词搜索…"
                    v-model="searchWord"
                    size="large"
                    :maxLength="255"
                    allowClear
                    @pressEnter="()=>search()"
                    @search="()=>search()"
                    style="width:100%"
                >
                    <a-button
                        slot="enterButton"
                        type="primary"
                    >
                        <eco-icon
                            name="search"
                            style="color:#333333"
                        ></eco-icon>
                    </a-button>
                </a-input-search>
            </div>
        </div>
        <content-cntr style="margin: -74px auto 0px;">
            <div style="position: relative;">
                <div style="position: absolute;z-index:8">
                    <menu-bar
                        :menuData="menuList"
                    ></menu-bar>
                </div>
            </div>
            <flex-row>
                <flex-fill class="left-list-container">
                    <card-item
                        v-for="v in content"
                        :item="v"
                        :key="v.id"
                    ></card-item>
                </flex-fill>
                <flex-fixed style="width: 320px;display:flex;flex-direction: column;margin-top: 166px;">
                    <AnnouncePanel style="flex:none"></AnnouncePanel>
                    <div style="height:24px;flex:none"></div>
                    <div style="flex:auto">
                        <ScrollFixed :fixedTop="94">
                            <CustomerPanel></CustomerPanel>
                            <div style="height:24px"></div>
                            <DMPlayground></DMPlayground>
                            <div style="height:60px"></div>
                        </ScrollFixed>
                    </div>
                </flex-fixed>
            </flex-row>
        </content-cntr>
    </div>
</template>

<script>
import ContentCntr from "../components/globe/ContentCntr.vue";
import CardItem from "./components/CardItem.vue";
import MenuBar from "./components/MenuBar.vue";
import AnnouncePanel from "../widget/AnnouncePanel.vue";
import CustomerPanel from "../widget/CustomerPanel.vue";
import DMPlayground from "../widget/DMPlayground.vue";
import ScrollFixed from "../widget/ScrollFixed.vue";
import { getMenuData, getListData } from "@/request/index.js";

export default {
    components: {
        MenuBar,
        ContentCntr,
        CardItem,
        AnnouncePanel,
        CustomerPanel,
        DMPlayground,
        ScrollFixed,
    },
    data() {
        return {
            menuList: [],
            content: [
                {
                    intro: {
                        title: "安装部署",
                        desc: "各类达梦数据库产品搭建部署指南，提供更为详细的最佳实践",
                        link: "",
                    },
                    list: [
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                    ],
                },
                {
                    intro: {
                        title: "安装部署",
                        desc: "各类达梦数据库产品搭建部署指南，提供更为详细的最佳实践",
                        link: "",
                    },
                    list: [
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                        {
                            title: "达梦数据库设计开发规范",
                            fileType: "word",
                            size: "1.23MB",
                            createTime: "2022-04-27",
                        },
                    ],
                },
            ],
            searchWord: "",
        };
    },
    mounted() {
        this.loadMenuData();
        this.loadListData();
    },
    methods: {
        search() {
            console.log("搜索：", this.searchWord);
            this.$router.push({
                path: "/search/",
                query: { value: this.searchWord, menu: "all" },
            });
        },
        loadMenuData() {
            getMenuData().then((result) => {
                this.menuList = result;
            });
        },
        loadListData() {
            getListData().then((result) => {
                this.content = result;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.vip-container {
    background: #f6f7fb;

    .header {
        background-image: url("../assets/VIP-bg.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        height: 380px;
        padding-top: 80px;

        .header-vip {
            background-image: url("../assets/VIP.svg");
            background-size: contain;
            background-repeat: no-repeat;
            width: 298px;
            height: 56px;
            margin: 0 auto;
        }

        .search-container {
            width: 544px;
            margin: 32px auto 0;
        }

        .search-container ::v-deep .ant-input {
            height: 48px !important;
            font-size: 16px;
            background: linear-gradient(
                90deg,
                rgba(61, 55, 45, 0.9) 0%,
                #403b30 100%
            );
            border: 1px solid rgba(244, 211, 148, 0.06);
            color: rgba(240, 205, 137, 1);
        }

        .search-container ::v-deep .ant-btn-lg {
            height: 48px;
            background: linear-gradient(
                159deg,
                #fee5b2 0%,
                #e6bb6e 62%,
                #fed68f 100%
            );
        }

        .search-container ::v-deep .ant-input::-webkit-input-placeholder {
            color: rgba(240, 205, 137, 0.65);
        }
        .search-container ::v-deep .ant-input::-moz-placeholder {
            color: rgba(240, 205, 137, 0.65);
        }
        .search-container ::v-deep .ant-input::placeholder {
            color: rgba(240, 205, 137, 0.65);
        }
        .search-container ::v-deep .ant-input:-ms-input-placeholder {
            color: rgba(240, 205, 137, 0.65);
        }

        .search-container ::v-deep .ant-input:focus {
            box-shadow: 0 0 0 2px rgba(244, 211, 148, 0.25);
        }
    }

    .left-list-container {
        overflow: hidden;
        margin-top: 166px;
        margin-bottom: 60px;
        background: $color-white;
        margin-right: 24px;
        padding: 24px;
    }
}
</style>
